/**
 * @see https://github.com/referenceable/referenceable_api/blob/develop/app/graphql/application/types/event_enum.rb
 */
export enum UserActivityEvent {
  ContentCreated = 'content_created',
  ContentDetailsEdited = 'content_details_edited',
  ContentDownloaded = 'content_downloaded',
  ContentUpdated = 'content_updated',
  ContentViewed = 'content_viewed',
  DailyActivity = 'daily_activity',
  LibraryFiltered = 'library_filtered',
  LibrarySearch = 'library_search',
  LinkCreated = 'link_created',
  LinkEdited = 'link_edited',
  LinkStatsViewed = 'link_stats_viewed',
  RoomCreated = 'room_created',
  RoomEdited = 'room_edited',
  RoomStatsViewed = 'room_stats_viewed',
}

export const AllUserActivityEvents = [
  UserActivityEvent.ContentCreated,
  UserActivityEvent.ContentDetailsEdited,
  UserActivityEvent.ContentDownloaded,
  UserActivityEvent.ContentUpdated,
  UserActivityEvent.ContentViewed,
  UserActivityEvent.DailyActivity,
  UserActivityEvent.LibraryFiltered,
  UserActivityEvent.LibrarySearch,
  UserActivityEvent.LinkCreated,
  UserActivityEvent.LinkEdited,
  UserActivityEvent.LinkStatsViewed,
  UserActivityEvent.RoomCreated,
  UserActivityEvent.RoomEdited,
  UserActivityEvent.RoomStatsViewed,
];

export const MTAllUserActivityEvents = [
  UserActivityEvent.DailyActivity,
  UserActivityEvent.RoomStatsViewed,
  UserActivityEvent.RoomCreated,
  UserActivityEvent.RoomEdited,
];
